module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Jonnie Hyde is a PhD psychologist living in SW Washington, where she founded and was executive director of a large community mental health center. After retiring in 2017, she decided to pursue her lifelong goal of writing a novel. And since she has been a close follower of climate science and climate change since reading Paul Ehrlic’s "), _c('em', [_vm._v("The Population Bomb")]), _vm._v(" in 1970, she decided to bring these two passions together in her novel, "), _c('em', [_vm._v("Irrevocable Acts.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0235a5e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0